import { render } from "./roomsImport.vue?vue&type=template&id=6fdcb1ba&scoped=true&ts=true"
import script from "./roomsImport.vue?vue&type=script&lang=ts"
export * from "./roomsImport.vue?vue&type=script&lang=ts"

import "./roomsImport.vue?vue&type=style&index=0&id=6fdcb1ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdcb1ba"]])

export default __exports__